
import { useMemo, useRef } from "react";

export type FocusHandoff = {
  handOff: () => void;
  onCloseAutoFocus: (event: Event) => void;
};

export function useFocusHandoff(): FocusHandoff {
  const handingOff = useRef(false);

  return useMemo(
    () => ({
      handOff: () => {
        handingOff.current = true;
      },
      onCloseAutoFocus: (event: Event) => {
        if (!handingOff.current) return;
        handingOff.current = false;
        event.preventDefault();
      },
    }),
    [],
  );
}
